<ng-container *ngIf="variableParamsChanged$ | async"></ng-container>
<div class="w-full flex flex-auto gap-3" cslEnterLikeTab>
  <div class="w-100-p flex flex-col flex-auto" cslEnterLikeTab>
    <div class="flex gap-3">
      <mat-form-field appearance="outline" [ngClass]="{ 'dense-input': dense }">
        <mat-label>X</mat-label>
        <input
        data-testid="xInput"
          type="number"
          [ngModel]="_X"
          #X="ngModel"
          (ngModelChange)="X.invalid ? null : paramChanged(xChange, 'X', $event)"
          matInput
          required
          [range]="[xMin, xMax]"
          number
          (click)="$any($event.target).select()"
          [disabled]="!editable" />
        <div i18n matSuffix>мм</div>
        <mat-error *ngIf="X.invalid"> ≥{{ xMin }}, ≤{{ xMax }} </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" [ngClass]="{ 'dense-input': dense }">
        <mat-label>Y</mat-label>
        <input
        data-testid="yInput"
          type="number"
          [ngModel]="_Y"
          #Y="ngModel"
          (ngModelChange)="Y.invalid ? null : paramChanged(yChange, 'Y', $event)"
          matInput
          required
          [range]="[yMin, yMax]"
          number
          (click)="$any($event.target).select()"
          [disabled]="!editable" />
        <div i18n matSuffix>мм</div>
        <mat-error *ngIf="Y.invalid"> ≥{{ yMin }}, ≤{{ yMax }} </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" [ngClass]="{ 'dense-input': dense }">
        <mat-label>R</mat-label>
        <input
        data-testid="rInput"
          type="number"
          [ngModel]="_R"
          #R="ngModel"
          (ngModelChange)="R.invalid ? null : paramChanged(rChange, 'R', $event)"
          matInput
          required
          [range]="[rMin, rMax]"
          number
          (click)="$any($event.target).select()"
          [disabled]="!editable" />
        <div i18n matSuffix>мм</div>
        <mat-error *ngIf="R.invalid"> ≥{{ rMin }}, ≤{{ rMax }} </mat-error>
      </mat-form-field>
    </div>

    <mat-form-field class="self-stretch">
      <mat-label i18n>Дополнительные параметры</mat-label>
      <mat-select [value]="mode" (selectionChange)="mode = $event.value">
        <mat-option [value]="'angle'" i18n>Углы</mat-option>
        <mat-option [value]="'side'" i18n>Стороны</mat-option>
      </mat-select>
    </mat-form-field>

    <div class="flex flex-row gap-3" [ngClass]="{ hidden: isSideMode() }">
      <mat-form-field appearance="outline" [ngClass]="{ 'dense-input': dense }">
        <mat-label>XA</mat-label>
        <input
        data-testid="xaInput"
          type="number"
          [ngModel]="_XA"
          #XA="ngModel"
          (ngModelChange)="XA.invalid ? null : paramChanged(xAChange, 'XA', $event)"
          matInput
          required
          [range]="[0, 180]"
          number
          (click)="$any($event.target).select()"
          [disabled]="!editable"
          cslDisableInputSpinEvents />
        <div matSuffix>°</div>
        <mat-error *ngIf="XA.invalid"> ≥{{ 0 }}, ≤{{ 180 }} </mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" [ngClass]="{ 'dense-input': dense }">
        <mat-label>YA</mat-label>
        <input
        data-testid="yaInput"
          type="number"
          [ngModel]="_YA"
          #YA="ngModel"
          (ngModelChange)="YA.invalid ? null : paramChanged(yAChange, 'YA', $event)"
          matInput
          required
          [range]="[0, 180]"
          number
          (click)="$any($event.target).select()"
          [disabled]="!editable"
          cslDisableInputSpinEvents />
        <div matSuffix>°</div>
        <mat-error *ngIf="YA.invalid"> ≥{{ 0 }}, ≤{{ 180 }} </mat-error>
      </mat-form-field>

      <div class="whitespace-nowrap font-semibold">
        <div>X1 = {{ _X1 | number : '1.0-3' }}</div>
        <div>Y1 = {{ _Y1 | number : '1.0-3' }}</div>
      </div>
    </div>

    <div class="flex flex-row gap-3" [ngClass]="{ hidden: !isSideMode() }">
      <mat-form-field appearance="outline" [ngClass]="{ 'dense-input': dense }">
        <mat-label>X1</mat-label>
        <input
        data-testid="x1Input"
          type="number"
          [ngModel]="_X1"
          #X1="ngModel"
          (ngModelChange)="X1.invalid ? null : paramChanged(x1Change, 'X1', $event)"
          matInput
          required
          [range]="[0, 5000]"
          number
          (click)="$any($event.target).select()"
          [disabled]="!editable"
          cslDisableInputSpinEvents />
        <div i18n matSuffix>мм</div>
        <mat-error *ngIf="X1.invalid"> ≥{{ 0 }}, ≤{{ 5000 }} </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline" [ngClass]="{ 'dense-input': dense }">
        <mat-label>Y1</mat-label>
        <input
        data-testid="y1Input"
          type="number"
          [ngModel]="_Y1"
          #Y1="ngModel"
          (ngModelChange)="Y1.invalid ? null : paramChanged(y1Change, 'Y1', $event)"
          matInput
          required
          [range]="[0, 5000]"
          number
          (click)="$any($event.target).select()"
          [disabled]="!editable"
          cslDisableInputSpinEvents />
        <div i18n matSuffix>мм</div>
        <mat-error *ngIf="Y1.invalid"> ≥{{ 0 }}, ≤{{ 5000 }} </mat-error>
      </mat-form-field>

      <div class="whitespace-nowrap font-semibold">
        <div>XA = {{ _XA | number : '1.0-3' }}</div>
        <div>YA = {{ _YA | number : '1.0-3' }}</div>
      </div>
    </div>

    <mat-error class="mb-4" *ngIf="paramsCalcError">{{ paramsCalcError }}</mat-error>
  </div>
</div>
